import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { motion } from 'framer-motion'

import { ContentViewProps } from 'modules/trainings/components/content/types'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'

export const PageBlockView = ({ contentItem }: ContentViewProps<PageBlock>) => {
  const [imageLoaded, setImageLoaded] = useState(false)

  return (
    <Box style={{ maxWidth: '720px', width: '100%', gap: '1rem' }}>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>

      {contentItem.thumbnail.url && (
        <Box
          style={{
            borderRadius: '1rem',
            overflow: 'hidden',
            aspectRatio: '16 / 9',
            backgroundColor: '#f0f0f0',
          }}
        >
          <motion.img
            src={contentItem.thumbnail.url}
            alt={contentItem.title}
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            onLoad={() => setImageLoaded(true)}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
      )}

      {contentItem.description && (
        <div
          className="text-base text-f1-foreground-secondary"
          style={{ lineHeight: '1.6' }}
          dangerouslySetInnerHTML={{ __html: contentItem.description }}
        />
      )}
    </Box>
  )
}
